<template>
    <nav :aria-label="$t('aria.barre.etapes.preavis')" class="step-bar-container">
        <ol class="step-list">
            <li class="step-item">
                <Step
                    :number="1"
                    :state="isActive(1)"
                    :subtitle="site?.description ?? ''"
                    :title="$t('intervention.bar.site')"
                />
            </li>
            <div aria-hidden="true" class="separator"></div>
            <li class="step-item">
                <Step
                    :number="2"
                    :state="isActive(2)"
                    :subtitle="equipementsSubtitle"
                    :title="$t('intervention.bar.equipement')"
                />
            </li>
            <div aria-hidden="true" class="separator"></div>
            <li class="step-item">
                <Step :number="3" :state="isActive(3)" :title="$t('preavisIntervention.saisie')" />
            </li>
        </ol>
    </nav>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import Step, { StepState } from '../../../components/ui-components/Step.vue';
import { Site } from '@/models/Site';

export default defineComponent({
    name: 'PreavisStepsBar',
    components: {
        Step,
    },
    props: {
        step: { type: Number, required: true },
        selectedEquipementsCount: { type: Number, default: 0 },
    },
    data() {
        return {
            StepState,
        };
    },
    methods: {
        isActive(n: number): StepState {
            if (n < this.step) {
                return StepState.valid;
            } else {
                return n === this.step ? StepState.active : StepState.inactive;
            }
        },
    },
    computed: {
        site(): Site | undefined {
            return this.$store.getters['preavisInterventionState/getPreavisSite'];
        },
        equipementsSubtitle(): string {
            if (this.selectedEquipementsCount === 0) return '';
            return `${this.selectedEquipementsCount} ${this.$tc(
                'preavisIntervention.stepbar.equipement',
                this.selectedEquipementsCount
            )}`;
        },
    },
});
</script>

<style scoped>
.step-bar-container {
    display: flex;
    justify-content: space-between;
    width: calc(100% - 48px);
    background-color: var(--white);
    height: 28px;
    align-items: center;
    padding: 16px 24px;
    box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px rgba(0, 0, 0, 0.14), 0 1px 5px rgba(0, 0, 0, 0.12);
}
.step-list {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin: 0;
    padding: 0;
    list-style: none;
}
.step-item {
    display: flex;
    align-items: center;
}
.separator {
    height: 1px;
    background-color: var(--medium-light-grey);
    flex-shrink: 1;
    min-width: 21px;
}
</style>
